function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 13.825a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4z",
  fill: "#D1D8DF"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 .625l-1.83 2H2c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2h-3.17l-1.83-2H7zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
  fill: "#D1D8DF"
});

var SvgCameraIcon = function SvgCameraIcon(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCameraIcon;